/* @jsx h */
import { defineComponent, h, ref } from "vue";
import { LemmonModal, useLocalization } from "@lemmonhq/uikit";

type Props = {
  title: string;
  drafts: number;
  open: number;
  flagged: number;
  busy: boolean;
  onDiscard: () => void;
  onApprove: (notify: boolean) => void;
  onClose: () => void;
};

// "Publish this schedule?" — the manager's approval step.
export const PublishModal = defineComponent<Props>({
  name: "PublishModal",
  props: ["title", "drafts", "open", "flagged", "busy", "onDiscard", "onApprove", "onClose"],
  setup(props) {
    const { t } = useLocalization();
    const notify = ref(true);
    return () => (
      <LemmonModal title={props.title} onClose={props.onClose} renderButtons={() => null}>
        <div class="space-y-4 p-6">
          <h3 class="text-2xl font-semibold">{t("workday.rota.publish_question")}</h3>
          <p class="text-sm text-base-content/70">{t("workday.rota.publish_help")}</p>
          <ul class="space-y-1 text-sm">
            <li class="flex items-center gap-2">
              <span class="material-symbols-outlined text-base text-primary">edit_calendar</span>
              {t("workday.rota.publish_drafts").replace("{count}", String(props.drafts))}
            </li>
            {props.open > 0 && (
              <li class="flex items-center gap-2 text-warning">
                <span class="material-symbols-outlined text-base">person_add</span>
                {t("workday.rota.publish_open").replace("{count}", String(props.open))}
              </li>
            )}
            {props.flagged > 0 && (
              <li class="flex items-center gap-2 text-error">
                <span class="material-symbols-outlined text-base">warning</span>
                {t("workday.rota.publish_flagged").replace("{count}", String(props.flagged))}
              </li>
            )}
          </ul>
          <label class="flex items-center gap-2 text-sm">
            <input type="checkbox" class="checkbox checkbox-sm" v-model={notify.value} />
            {t("workday.rota.publish_notify")}
          </label>
          <div class="grid grid-cols-2 gap-3 pt-2">
            <button class="btn" disabled={props.busy} onClick={() => props.onDiscard()}>
              {t("workday.rota.discard_draft")}
            </button>
            <button class="btn btn-primary" disabled={props.busy || props.drafts === 0} onClick={() => props.onApprove(notify.value)}>
              {t("workday.rota.approve")}
            </button>
          </div>
        </div>
      </LemmonModal>
    );
  },
});
